import { CSSProperties, ReactElement, ReactNode } from 'react';
import { palette } from '@instamenu/ui-vanilla-extract';
import { Box } from '../box/box';
import { Text } from '../text/text';

type FormFieldProps = {
  error?: false | string;
  element: ReactElement;
  css?: CSSProperties;
  label?: string;
  description?: ReactNode;
  required?: boolean;
};

export const FormField = ({
  element,
  error,
  label,
  description,
  required,
  css,
}: FormFieldProps) => {
  return (
    <Box css={{ ...css, marginBottom: 16, textAlign: 'left' }}>
      {label && (
        <Text as="label" css={{ display: 'block', marginBottom: 4 }}>
          {label}
          {required && (
            <Text as="span" css={{ color: 'red' }}>
              *
            </Text>
          )}
        </Text>
      )}
      {description && (
        <Text
          variant="caption1"
          css={{ display: 'block', color: palette.gray500, marginBottom: 8 }}
        >
          {description}
        </Text>
      )}
      {element}
      <Box css={{ marginTop: 4, height: 6 }}>
        {error && (
          <Text error css={{ marginTop: 4 }}>
            {error}
          </Text>
        )}
      </Box>
    </Box>
  );
};

export default FormField;
